
import _ from "lodash";
import matcher from "./wizardFieldMatcher";

const ROOT = { root: true };

const buildStep = (path, args = {}, order = 1) => ({
	path,
	order,
	args: JSON.stringify(args),
});

const getters = {
	modeOptions: (s, g, rs, rootGetters) => [
		{ text: "Cool", value: "cool" },
		{ text: "Heat", value: "heat" },
		{ text: "Auto", value: "auto" },
		{ text: "Magic", value: "magic", disabled: !rootGetters["controller/nodes/actionServer"] }
	],
	sceneNodes: (s, g, rs, rootGetters) => rootGetters["scenes/sceneNodes"],
	timeNode: (s, getters) => _.get(getters.sceneNodes, "timeConditions", []).find(condition => condition.operator === "=="),
	modeNodes: (s, getters) => _.get(getters.sceneNodes, "commands", [])
		.filter(command => ["setMode", "enableSmartMode", "disableSmartMode"].includes(command.target.name)),
	tempNodes: (s, getters) => _.get(getters.sceneNodes, "commands", [])
		.filter(command => command.args.temp),
};

const actions = {
	// TODO cancel addition if it throws an error (i.e. delete scene if created)
	async create({ dispatch }, { form }) {
		const promises = [];

		// Create scene
		await dispatch("scenes/addScene", form, ROOT);

		// Set time condition
		promises.push(dispatch("setTime", { form }));

		// Set thermostat mode and temperature
		promises.push(dispatch("setTempMode", { form }));

		await Promise.all(promises);
		return true;
	},

	async update({ dispatch }, { form, fields = [], scene: { name } }) {
		if (!fields.length) return;
		const promises = [];
		if (fields.includes("time")) {
			promises.push(dispatch("setTime", { form: { ...form, name }, edit: true }));
		}
		if (fields.some(field => ["mode", "temp", "thermostat"].includes(field))) {
			promises.push(dispatch("setTempMode", { form: { ...form, name }, edit: true }));
		}
		await Promise.all(promises);

		if (fields.includes("name")) {
			await dispatch("scenes/renameScene", form, ROOT);
		}

		return true;
	},

	async setTime({ dispatch, getters, rootGetters }, { form: { name, time }, edit = false }) {
		const controllerPath = rootGetters["controller/nodes/controller"]
			.path;
		const action = `scenes/${edit ? "updateCondition" : "addCondition"}`;
		await dispatch(action, {
			parent: {
				path: `Triggers/${name}`,
			},
			node: getters.timeNode,
			condition: {
				path: `${controllerPath}/variables/clock/time`,
				operator: "==",
				value: time,
			}
		}, ROOT);
	},

	async setTempMode({ dispatch, getters, rootGetters }, { form: { name, temp, cool, heat, mode, thermostat }, edit = false }) {
		const actionServerPath = `${rootGetters["controller/nodes/controller"].path}/Servers/Action/commands`;
		const scene = {
			path: `Scenes/${name}`, // scene path
		};
		const oldTempMode = _.filter([
			...getters.modeNodes,
			...getters.tempNodes,
		]);

		if (mode === "magic") {
			await dispatch("scenes/addStep", {
				scene,
				step: buildStep(`${actionServerPath}/enableSmartMode`, {
					thermostatPath: thermostat,
					temperature: temp,
				}),
			}, ROOT);
		} else if (mode) {
			await dispatch("scenes/addStep", {
				scene,
				step: buildStep(`${actionServerPath}/disableSmartMode`, { thermostatPath: thermostat })
			}, ROOT);
			await dispatch("scenes/addStep", {
				scene,
				step: buildStep(`${thermostat}/commands/setMode`, { mode }, 2),
			}, ROOT);
			if (["auto", "heat"].includes(mode)) {
				await dispatch("scenes/addStep", {
					scene,
					step: buildStep(`${thermostat}/commands/setHeat`, { temp: heat }, 3),
				}, ROOT);
			}
			if (["auto", "cool"].includes(mode)) {
				await dispatch("scenes/addStep", {
					scene,
					step: buildStep(`${thermostat}/commands/setCool`, { temp: cool }, 4),
				}, ROOT);
			}
		}

		// Instead of updating each node depending on past settings,
		// just add the new ones and remove the old ones:
		if (edit) {
			for (const node of oldTempMode)
				await dispatch("controller/nodes/remove", node, ROOT);
		}
	},

	matchWizard: {
		root: true,
		handler(ctx, parsedScene) {
			// match parent parseScene with wizardFieldMatch
			// matches.temperature

			let match = matcher("temperature", parsedScene);

			return {
				wizard: "temperature",
				match
			};
		}
	},
};

export default {
	namespaced: true,
	getters,
	actions,
};
